import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { COOKIE_AUTH_DETAILS, pageUrls, ROLES } from 'globalconfig/constants/keys';
import { getCookie } from 'globalservices/cookie';
import { hasRestrictedRole, isdvirOnly, getQueryStringKeys } from 'globalutils/fmUtils';

const InitialLoad = ({ history, clearRedux, fetchLogin }) => {
  useEffect(() => {
    const token = getCookie(COOKIE_AUTH_DETAILS);
    const isDVIROnlyFlagEnabled = isdvirOnly();
    const redirectionURL = getQueryStringKeys(history.location?.search, 'redirect');

    const redirectTo = (url) => history.push(url);

    if (!token || (redirectionURL && redirectionURL.includes(window.$environment?.FLEETOPS_URL))) {
      return redirectTo(pageUrls.login);
    }

    if (hasRestrictedRole(['OWNER'])) {
      if (window.$environment.SERVICE_PROVIDER === 'clutch') {
        if (isDVIROnlyFlagEnabled) {
          return redirectTo(
            hasRestrictedRole([ROLES.SERVICE_MANAGER])
              ? pageUrls.unassignedInspections
              : pageUrls.pendingMechanicInspections
          );
        }
        return redirectTo(
          token?.onboardCompleted ? pageUrls.dashboard : pageUrls.welcome
        );
      }

      if (isDVIROnlyFlagEnabled) {
        return redirectTo(
          hasRestrictedRole([ROLES.SERVICE_MANAGER])
            ? pageUrls.unassignedInspections
            : pageUrls.pendingMechanicInspections
        );
      }

      return redirectTo(pageUrls.dashboard);
    }

    if (isDVIROnlyFlagEnabled) {
      return redirectTo(
        hasRestrictedRole([ROLES.SERVICE_MANAGER])
          ? pageUrls.unassignedInspections
          : pageUrls.pendingMechanicInspections
      );
    }

    if (hasRestrictedRole(['FLMANAGER'])) {
      return redirectTo(pageUrls.dashboard);
    }

    if (hasRestrictedRole(['MECHANIC'])) {
      return redirectTo(pageUrls.workOrders);
    }

    if (hasRestrictedRole(['DRIVER'])) {
      return redirectTo(
        window.$environment.SERVICE_PROVIDER === 'spireon' || window.$environment.SERVICE_PROVIDER === 'riskTheory'
          ? pageUrls.profile
          : pageUrls.logsList
      );
    }

    redirectTo(pageUrls.dashboard);
  }, []);

  return <></>;
};

const mapState = (state) => ({
  apiStatus: state.asyncRequests,
  login: state.login,
});

const mapDispatch = (dispatch) => ({
  fetchLogin: (data) => dispatch.login.fetchData(data),
  clearRedux: () => dispatch({ type: 'RESET_APP' }),
});

export default connect(mapState, mapDispatch)(InitialLoad);

InitialLoad.defaultTypes = {};
InitialLoad.propTypes = {};